import { useState, useEffect } from "react";
import "./App.css";
import BeforeWeBeginCard from "./components/before-we-begin-card/BeforeWeBeginCard";
// import BeforeWeBegin from "./components/before-we-begin/BeforeWeBegin";//
import Book from "./components/book/Book";
import BottomContent from "./components/bottom-content/BottomContent";
import CardCarousel from "./components/card-carousel/CardCarousel";
import CardScroll from "./components/card-scroll/CardScroll";
import ClientCarousel from "./components/client-carousel/ClientCarousel";
import Faq from "./components/faq/Faq";
import Header from "./components/header/Header";
import HeroBanner from "./components/hero-banner/HeroBanner";
// import VideoService from "./components/video-service/VideoService";
import VideoTestimonial from "./components/video-testimonial/VideoTestimonial";
import New from "./components/new/New";
import Temp from "./components/temp/Temp";
import ContactModal from "./components/contact-modal/ContactModal";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
// import VideoTransitionExamples from "./video-transitions-curtains-close";
// import VideoTransitionExamples from "./video-transitions";
function FaqAnimatedCircles() {
  return (
    <div className="faq-animated-circles-wrapper">
      <div className="faq-animated-circle1" />
      <div className="faq-animated-circle2" />
    </div>
  );
}

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("home");

  useEffect(() => {
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };

    window.addEventListener('openContactModal', handleOpenContactModal);
    
    // Handle hash-based routing
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === "terms-of-use" || hash === "privacy-policy") {
        setCurrentPage(hash);
      } else {
        setCurrentPage("home");
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('openContactModal', handleOpenContactModal);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  if (currentPage === "terms-of-use") {
    return <TermsOfUse />;
  }

  if (currentPage === "privacy-policy") {
    return <PrivacyPolicy />;
  }

  return (
    <>
      <Header onContactClick={() => setIsContactModalOpen(true)} />
      <HeroBanner />
      {/* <VideoTransitionExamples /> */}
      <New />
      <Temp />
      <CardScroll />
      <ClientCarousel />
      <CardCarousel />
      {/* <VideoService /> */}
      {/* <div className="bwg-main-container-wrapper"> */}
        {/* <div className="bwg-main-container-wrapper-bg"></div> */}
        {/* <BeforeWeBegin /> */}
        <BeforeWeBeginCard />
      {/* </div> */}
      <Book />
      <div className="end-content-wrapper">
        <div className="end-content-background-circle"></div>
        <VideoTestimonial />
        <div style={{ position: "relative" }}>
          <FaqAnimatedCircles />
          <Faq />
        </div>
        <BottomContent onContactClick={() => setIsContactModalOpen(true)} />
      </div>
      <footer className="copyright-footer">
        <p>
          Copyright © Speak With Simon 2026. All Rights Reserved. "TED" and "TEDx" are trademarks of TED Conferences LLC. Emergency Speaker Coach is independent and not affiliated with, sponsored by, or endorsed by TED Conferences LLC or its affiliates.
        </p>
        <div className="copyright-footer-links">
          <a href="#terms-of-use" onClick={(e) => { e.preventDefault(); setCurrentPage("terms-of-use"); window.location.hash = "terms-of-use"; }}>Terms of Use</a>
          <a href="#privacy-policy" onClick={(e) => { e.preventDefault(); setCurrentPage("privacy-policy"); window.location.hash = "privacy-policy"; }}>Privacy Policy</a>
        </div>
      </footer>
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </>
  );
}

export default App;
